<script setup lang="ts">
import SaiLoader from '@/components/common/SaiLoader/index.ce.vue';

//props
const props = defineProps({
    selector: { type: String, default: 'sai-modal-container', required: false },
    display: { type: Boolean, default: false, required: false },
    className: { type: String, default: '', required: false },
    processing: { type: Boolean, default: false, required: false }
});

  const emit = defineEmits(['closeModal'])
  const closeModal = (event: Event) => {
    emit('closeModal', event)
  }
</script>
<template>
  <Teleport to="body">
    <div ref="elem" :class="'sai-modal-popup-v3wc show ' + className" v-if="display">
      <div class="modal-content">
        <SaiLoader v-if="processing" type="threedotflash"></SaiLoader>
        <div class="modal-header">
          <slot name="title"></slot>
          <span class="close-popup" @click="closeModal">
            <img style="vertical-align: top;" src="@/assets/img/icon-close-modal.svg" alt="Close" />
          </span>
        </div>
        <div class="sai-modal-body">
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>